import styled from '@emotion/styled'

export const MATERIAL_COMPONENTS_OVERRIDES = {
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        backgroundColor: '#f3f3f3',
        fontFamily: 'FSEmeric-Regular',
      },
    },
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: '#ffffff !important',
          '&:hover': {
            backgroundColor: '#ffffff !important',
          },
        },
      },
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        backgroundColor: 'rgba(0, 65, 101, 0.1)',
        '&.Mui-expanded': {
          backgroundColor: 'rgba(0, 65, 101, 0.1)',
        },
      },
    },
  },
  MuiAccordionDetails: {
    styleOverrides: {
      root: {
        padding: '16px',
      },
    },
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        width: '100%',
        marginTop: '0 !important',
        marginBottom: '0 !important',
        '&.MuiFormControl-marginNormal': {
          marginTop: '0 !important',
          marginBottom: '0 !important',
        },
        '&.MuiFormControl-marginNone': {
          marginTop: '0 !important',
          marginBottom: '0 !important',
        },
      },
    },
  },
  MuiGrid: {
    styleOverrides: {
      item: {
        display: 'flex !important',
        flexDirection: 'column !important',
        alignItems: 'flex-start !important',
        boxSizing: 'border-box !important',
      },
      container: {
        display: 'flex !important',
        flexWrap: 'wrap !important',
      },
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: {
        backgroundColor: '#ffffff',
      },
      input: {
        height: 'auto', // '-webkit-fill-available' puede dar problemas, 'auto' o '100%' es más seguro
        fontSize: 16,
        fontFamily: 'FSEmeric-Regular',
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        '&:-webkit-autofill': {
          transition: 'background-color 5000s ease-in-out 0s',
          WebkitBoxShadow: '0 0 0 100px #ffffff inset',
        },
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        fontSize: '14px',
      },
      sizeLarge: {
        height: 48,
      },
      containedInherit: {
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.15)',
        },
      },
    },
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {},
      content: {
        display: 'block',
        '&.Mui-expanded': {
          margin: '12px 0',
        },
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        boxSizing: 'border-box',
      },
      head: {
        fontWeight: 'normal !important',
      },
    },
  },
  MuiContainer: {
    styleOverrides: {
      root: {
        paddingLeft: '16px',
        paddingRight: '16px',
        '@media (min-width: 600px)': {
          paddingLeft: '20px',
          paddingRight: '20px',
        },
        '&.MuiContainer-maxWidthLg': {
          maxWidth: '1280px !important',
          '@media (min-width: 1280px)': {
            maxWidth: '1280px !important',
          },
        },
        '&.MuiContainer-maxWidthXl': {
          maxWidth: '1600px !important',
          '@media (min-width: 1536px)': {
            maxWidth: '1600px !important',
          },
        },
        '&.applications-page-container': {
          maxWidth: 'calc(100vw - 32px) !important',
          '@media (min-width: 1200px)': {
            maxWidth: 'calc(100vw - 40px) !important',
          },
        },
      },
    },
  },
  MuiDataGrid: {
    styleOverrides: {
      root: {
        border: '1px solid #e0e0e0',
        '& .MuiDataGrid-cell': {
          height: '40px',
          fontSize: '14px',
          color: '#63666a',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxHeight: '40px',
          boxSizing: 'border-box',
        },
        '& .MuiDataGrid-cell:focus': {
          outline: 'none',
        },
        '& .MuiDataGrid-columnHeaders': {
          height: '40px',
          fontSize: '14px',
          color: '#1a171b',
          backgroundColor: 'rgba(0, 65, 101, 0.1)',
          border: 'none',
          boxSizing: 'border-box',
        },
        '& .MuiDataGrid-row': {
          height: '40px',
        },
        '@media (min-width: 960px)': {
          '& .MuiDataGrid-main': {
            minWidth: '100%',
          },
        },
        '@media (min-width: 1280px)': {
          '& .MuiDataGrid-virtualScroller': {
            minHeight: '400px',
          },
        },
        '&.fixed-columns-right .MuiDataGrid-columnHeader:last-child': {
          position: 'sticky',
          right: 0,
          backgroundColor: 'rgba(0, 65, 101, 0.1)',
          zIndex: 1,
          borderLeft: '1px solid #e0e0e0',
        },
        '&.fixed-columns-right .MuiDataGrid-cell:last-child': {
          position: 'sticky',
          right: 0,
          backgroundColor: '#fff',
          zIndex: 1,
          borderLeft: '1px solid #e0e0e0',
        },
        '&.fixed-columns-right .MuiDataGrid-row:hover .MuiDataGrid-cell:last-child': {
          backgroundColor: '#f5f5f5',
        },
        '& .MuiDataGrid-overlayWrapper': {
          top: 0,
        },
      },
    },
  },
  MuiTable: {
    styleOverrides: {
      root: {
        tableLayout: 'auto',
      },
    },
  },
  MuiTableContainer: {
    styleOverrides: {
      root: {
        overflowX: 'auto',
      },
    },
  },
}
